import React, { useCallback, useContext, useEffect, useMemo, useReducer } from 'react';

const TabbyScriptContext = React.createContext();

const TABBY_SCRIPT_URL = 'https://checkout.tabby.ai/tabby-promo.js';

const injectJS = (onLoad) => {
  const tjs = document.getElementsByTagName('script')[0];
  if (document.getElementById('tabby-jssdk')) return;
  const js = document.createElement('script');
  js.async = 1; js.defer = 1;
  js.crossorigin = 'anonymous';
  js.id = 'tabby-jssdk';
  js.src = TABBY_SCRIPT_URL;
  js.onload = onLoad;
  tjs.parentNode.insertBefore(js, tjs);
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'set-loaded': return { ...state, loaded: true };
    case 'set-should-load': return { ...state, shouldLoad: true };
    default: throw new Error(`Unhandled action type: ${action.type}`);
  }
};

// Inject the tabby promo messages script
export const TabbyScriptProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    loaded: false,
    shouldLoad: false
  });
  const { loaded, shouldLoad } = state;

  // This guarantees that the script will be injected exactly once.
  useEffect(() => {
    if (shouldLoad) {
      injectJS(() => dispatch({ type: 'set-loaded' }));
    }
  }, [shouldLoad]);

  const load = useCallback(() => {
    dispatch({ type: 'set-should-load' });
  }, []);

  const value = useMemo(() => {
    return {
      TabbyPromo: loaded ? window.TabbyPromo : null,
      ensureLoaded: load,
      loaded: loaded
    };
  }, [loaded, load]);

  return (
    <TabbyScriptContext.Provider value={value}>
      {children}
    </TabbyScriptContext.Provider>
  );
};

export const useTabbyPromoScript = () => {
  const context = useContext(TabbyScriptContext);
  if (!context) throw new Error('useTabbyPromoScript must be used within a TabbyScriptProvider');
  return context;
};
